
import { mediaQueries } from '../shared/config';

import styled from 'styled-components';


    const Container = styled.div`
    z-index: 10;
    margin-left: 30%;
    transform: translate(0, -35vh); /* Translate the component */
    width: 70vh;
    height: fit-content;
    min-height: 20vh;
    background: rgba(255, 255, 255, 0.75);
    border-radius: 16px;
    border-style: solid;
    border-color: white;
    border-width: 1px;

    ${mediaQueries.mobile} {
        width: 40vh;
        transform: translate(-12vh, -30vh); /* Translate the component */

    }
`

const Title = styled.div`
    font-family: "Playfair Display", serif;
    font-weight: 400px;
    font-size: 4.2vh;
    text-align: left;
    // margin-left: 3vh;
    // margin-right: 9vh;
    // margin-top: 3vh;
    // margin-bottom: 0vh;
    color:#9E7EC7;
    padding: 6vh;
    padding-left: 8vh;
    padding-right: 8vh;

    ${mediaQueries.mobile} {
        font-size: 3.2vh;
        padding-left: 4vh;
        padding-right: 4vh;
    }

`


const BlurbTwo = ({props}) => {
    // console.log(props)
    return (
      <a href={props.blurb_url} style={{ textDecoration: 'none' }}>
    <Container >
    <Title>{props.blurb_text}</Title>
    </Container>
      </a>
    );
  };

export default BlurbTwo;